import $ from '../vendor/jquery';

$('.block-accordion .accordion-toggle').click(function(e) {
  $(this).parents('.block-accordion').toggleClass('open');
  $(this).parent().find('.accordion-content').slideToggle();

  if ($(this).parents('.block-accordion').hasClass('open')) {
    $(this).children('.accordion-toggle-button').attr('aria-expanded', 'true');
    $(this).children('.accordion-toggle-button').attr('aria-label', 'Hide accordion content');
  }
  else {
    $(this).children('.accordion-toggle-button').attr('aria-expanded', 'false');
    $(this).children('.accordion-toggle-button').attr('aria-label', 'Show accordion content');
  }
});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/accordions.js